import React, {Component} from 'react'
import ReactCrop from "react-image-crop";
import Button from "react-bootstrap/es/Button";

export default class Crop extends Component {

    constructor(props) {
        super(props);

        let crop = {aspect: 1920 / 600};

        if (this.props.zdjecieKlient) {
            crop = {aspect: 3 / 4}
        }

        this.state = {
            crop: crop,
            croppedImageUrl: '',
            disabled: true,
        }
    }

    onImageLoaded = (image, pixelCrop) => {
        this.imageRef = image;
    };

    onCropComplete = async (crop, pixelCrop) => {
        const croppedImageUrl = await this.getCroppedImg(
            this.imageRef,
            pixelCrop,
            "newFile.jpeg"
        );
        this.setState({croppedImageUrl: croppedImageUrl});
    };

    onCropChange = crop => {
        this.setState({crop});
        this.setState({disabled: false})
    };

    getCroppedImg(image, pixelCrop, fileName) {
        const canvas = document.createElement("canvas");
        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
            image,
            pixelCrop.x,
            pixelCrop.y,
            pixelCrop.width,
            pixelCrop.height,
            0,
            0,
            pixelCrop.width,
            pixelCrop.height
        );

        const base64Image = canvas.toDataURL('image/jpeg');
        return base64Image
    }

    cropAndUpload() {
        this.props.setImage(this.state.croppedImageUrl);
        if (!this.props.zdjecieKlient) {
            this.props.closeModal()
        }
    }

    render() {
        return <div className="text-center">
            <p>Aby wykadrować obraz przeciągnij kursor nad wybranym elementem zdjęcia.</p>
            <ReactCrop
                src={this.props.cropItem}
                crop={this.state.crop}
                minWidth={50}
                minHeight={50}
                onImageLoaded={this.onImageLoaded}
                onComplete={this.onCropComplete}
                onChange={this.onCropChange}
                style={{maxWidth: '75%', maxHeight: '75%'}}
            />
            <div className="text-right">
                <Button bsStyle={'danger'} onClick={() => this.props.anuluj()}>Anuluj</Button>
                <Button bsStyle={'success'} disabled={this.state.disabled} style={{marginLeft: 10}}
                        onClick={() => this.cropAndUpload()}>Kadruj i wybierz</Button>
            </div>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/admin/adminComponents/galeriaComponents/Crop.js